export default {
    main: '#000000',
    contrastText: '#fff'
};
